"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetIndexName = void 0;
var AssetIndexName;
(function (AssetIndexName) {
    AssetIndexName["IMAGE"] = "imcc-assets";
    AssetIndexName["GRAPHIC_SYMBOL"] = "imcc-graphic-symbols";
    AssetIndexName["PUBLICATION"] = "imcc-publications";
    AssetIndexName["STORE_COMMUNICATION"] = "imcc-store-communications";
})(AssetIndexName = exports.AssetIndexName || (exports.AssetIndexName = {}));
//# sourceMappingURL=asset-index-name.js.map